// LiveStreamAsideTopPanel.js
'use strict';
import { connect } from 'react-redux';

import LiveStreamAsideTopPanel from '../component/LiveStreamAsideTopPanel.jsx';
import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import {
  getHasStreamToken,
  getLivestreamMode,
  getIsMeExclusivePrivateOngoingInitiator,
} from '../selector/getLivestreamComputedData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';
import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import {
  LivestreamMode,
  ExclusivePrivateStatus,
  privateShowStatus as PrivateShowStatus,
} from '../resource/liveStreamConstants.js';

const ONGOING_PRIVATE_SHOW_STATUSES = [
  PrivateShowStatus.FUNDING,
  PrivateShowStatus.FUNDING_FINAL_CALL,
  PrivateShowStatus.CONSIDERING,
  PrivateShowStatus.PREPARING,
  PrivateShowStatus.PERFORMING,
];

const mapStateToProps = (state, { streamId }) => {
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const hasStreamToken = getHasStreamToken(state, streamId);
  const livestreamMode = getLivestreamMode(state, streamId);
  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );

  return {
    streamStatus,
    hasStreamToken,
    isAsideTopPanelExpanded: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isAsideTopPanelExpanded'
    ),
    isOneOnOne: livestreamMode === LivestreamMode.ONE_VS_ONE,
    isPrivateShow: ONGOING_PRIVATE_SHOW_STATUSES.includes(
      getPrivateShowStatus(state, streamId)
    ),
    isExclusivePrivatePerforming:
      exclusivePrivateStatus === ExclusivePrivateStatus.PERFORMING,
    isMeExclusivePrivateOngoingInitiator:
      getIsMeExclusivePrivateOngoingInitiator(state, streamId),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setLiveStreamPanel: ({ ...data }) =>
      dispatch(setLiveStreamPanel({ ...data })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamAsideTopPanel);
